<template>
  <div class="driedLeaf">
    <div class="driedLeaf-lg">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3" border>
    <el-descriptions-item label="自编号" prop="oneselfNumber">
      {{ infoContent.oneselfNumber }}
    </el-descriptions-item>
    <el-descriptions-item label="采集编号" prop="collectNumber">
      {{ infoContent.collectNumber }}
    </el-descriptions-item>
    <el-descriptions-item label="资源类型" prop="resourceType">
      {{ infoContent.resourceType }}
    </el-descriptions-item>
    <el-descriptions-item label="资源保存条件" prop="preservationCondition">
      {{ infoContent.preservationCondition }}
    </el-descriptions-item>
    <el-descriptions-item label="资源保存前预处理" prop="pretreatment">
      {{ infoContent.pretreatment }}
    </el-descriptions-item>
    <el-descriptions-item label="可共享资源总量（粒）" prop="shareNum">
      {{ infoContent.shareNum }}
    </el-descriptions-item>
    <el-descriptions-item label="采集时间" prop="collectTime">
      {{ infoContent.collectTime }}
    </el-descriptions-item>
    <el-descriptions-item label="采集单位" prop="collectUnit">
      {{ infoContent.collectUnit }}
    </el-descriptions-item>

    <el-descriptions-item label="课题负责人" prop="projectLeader">
      {{ infoContent.projectLeader }}
    </el-descriptions-item>
    <el-descriptions-item label="科中文名" prop="sectionChinese">
      {{ infoContent.sectionChinese }}
    </el-descriptions-item>
    <el-descriptions-item label="科拉丁名" prop="sectionLatin">
      {{ infoContent.sectionLatin }}
    </el-descriptions-item>
    <el-descriptions-item label="种中文名" prop="growChinese">
      {{ infoContent.growChinese }}
    </el-descriptions-item>
    <el-descriptions-item label="种拉丁名" prop="growLatin">
      {{ infoContent.growLatin }}
    </el-descriptions-item>
    <el-descriptions-item label="鉴定者" prop="authenticateUser">
      {{ infoContent.authenticateUser }}
    </el-descriptions-item>
    <el-descriptions-item label="鉴定日期" prop="authenticateTime">
      {{ infoContent.authenticateTime }}
    </el-descriptions-item>
    <el-descriptions-item label="采集人" prop="collectUser">
      {{ infoContent.collectUser }}
    </el-descriptions-item>

    <el-descriptions-item label="国家" prop="country">
      {{ infoContent.country }}
    </el-descriptions-item>
    <el-descriptions-item label="省自治区" prop="province">
      {{ infoContent.province }}
    </el-descriptions-item>
    <el-descriptions-item label="地区" prop="area">
      {{ infoContent.area }}
    </el-descriptions-item>
    <el-descriptions-item label="区县" prop="district">
      {{ infoContent.district }}
    </el-descriptions-item>
    <el-descriptions-item label="具体地点" prop="address">
      {{ infoContent.address }}
    </el-descriptions-item>
    <el-descriptions-item label="经度" prop="longitude">
      {{ infoContent.longitude }}
    </el-descriptions-item>
    <el-descriptions-item label="纬度" prop="latitude">
      {{ infoContent.latitude }}
    </el-descriptions-item>

    <el-descriptions-item label="海拔高度" prop="elevation">
      {{ infoContent.elevation }}
    </el-descriptions-item>
    <el-descriptions-item label="生境" prop="habitat">
      {{ infoContent.habitat }}
    </el-descriptions-item>
    <el-descriptions-item label="伴生物种" prop="companionSpecies">
      {{ infoContent.companionSpecies }}
    </el-descriptions-item>
    <el-descriptions-item label="植物习性" prop="plantHabit">
      {{ infoContent.plantHabit }}
    </el-descriptions-item>
    <el-descriptions-item label="植株高度" prop="plantHeight">
      {{ infoContent.plantHeight }}
    </el-descriptions-item>
    <el-descriptions-item label="其它描述" prop="otherDescriptions">
      {{ infoContent.otherDescriptions }}
    </el-descriptions-item>
    <el-descriptions-item label="凭证标本馆存放地" prop="storagePlace">
      {{ infoContent.storagePlace }}
    </el-descriptions-item>
    <el-descriptions-item label="凭证标本馆藏号" prop="hideNo" span="3">
      {{ infoContent.hideNo }}
    </el-descriptions-item>

    <el-descriptions-item v-if="infoContent.pictureVideoFileList.length > 0"
                          label="图片展示" span="3"  class="img">
      <!--         <template slot-scope="scope">-->
      <el-carousel :interval="2000" arrow="always" class="carousel">
        <el-carousel-item v-for="item in infoContent.pictureVideoFileList"
                          :key="item.id">
          <img :src="item.url" alt="" class="carousel-img">
        </el-carousel-item>
      </el-carousel>
      <!--         </template>-->
    </el-descriptions-item>
  </el-descriptions>
    </div>
    <div class="driedLeaf-sm">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3" border>
        <el-descriptions-item label="自编号" prop="oneselfNumber" span="3">
          {{ infoContent.oneselfNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="采集编号" prop="collectNumber" span="3">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="资源类型" prop="resourceType" span="3">
          {{ infoContent.resourceType }}
        </el-descriptions-item>
        <el-descriptions-item label="资源保存条件" prop="preservationCondition" span="3">
          {{ infoContent.preservationCondition }}
        </el-descriptions-item>
        <el-descriptions-item label="资源保存前预处理" prop="pretreatment" span="3">
          {{ infoContent.pretreatment }}
        </el-descriptions-item>
        <el-descriptions-item label="可共享资源总量（粒）" prop="shareNum" span="3">
          {{ infoContent.shareNum }}
        </el-descriptions-item>
        <el-descriptions-item label="采集时间" prop="collectTime" span="3">
          {{ infoContent.collectTime }}
        </el-descriptions-item>
        <el-descriptions-item label="采集单位" prop="collectUnit" span="3">
          {{ infoContent.collectUnit }}
        </el-descriptions-item>

        <el-descriptions-item label="课题负责人" prop="projectLeader" span="3">
          {{ infoContent.projectLeader }}
        </el-descriptions-item>
        <el-descriptions-item label="科中文名" prop="sectionChinese" span="3">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin" span="3">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="种中文名" prop="growChinese" span="3">
          {{ infoContent.growChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="种拉丁名" prop="growLatin" span="3">
          {{ infoContent.growLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="鉴定者" prop="authenticateUser" span="3">
          {{ infoContent.authenticateUser }}
        </el-descriptions-item>
        <el-descriptions-item label="鉴定日期" prop="authenticateTime" span="3">
          {{ infoContent.authenticateTime }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser" span="3">
          {{ infoContent.collectUser }}
        </el-descriptions-item>

        <el-descriptions-item label="国家" prop="country" span="3">
          {{ infoContent.country }}
        </el-descriptions-item>
        <el-descriptions-item label="省自治区" prop="province" span="3">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area" span="3">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="区县" prop="district" span="3">
          {{ infoContent.district }}
        </el-descriptions-item>
        <el-descriptions-item label="具体地点" prop="address" span="3">
          {{ infoContent.address }}
        </el-descriptions-item>
        <el-descriptions-item label="经度" prop="longitude" span="3">
          {{ infoContent.longitude }}
        </el-descriptions-item>
        <el-descriptions-item label="纬度" prop="latitude" span="3">
          {{ infoContent.latitude }}
        </el-descriptions-item>

        <el-descriptions-item label="海拔高度" prop="elevation" span="3">
          {{ infoContent.elevation }}
        </el-descriptions-item>
        <el-descriptions-item label="生境" prop="habitat" span="3">
          {{ infoContent.habitat }}
        </el-descriptions-item>
        <el-descriptions-item label="伴生物种" prop="companionSpecies" span="3">
          {{ infoContent.companionSpecies }}
        </el-descriptions-item>
        <el-descriptions-item label="植物习性" prop="plantHabit" span="3">
          {{ infoContent.plantHabit }}
        </el-descriptions-item>
        <el-descriptions-item label="植株高度" prop="plantHeight" span="3">
          {{ infoContent.plantHeight }}
        </el-descriptions-item>
        <el-descriptions-item label="其它描述" prop="otherDescriptions" span="3">
          {{ infoContent.otherDescriptions }}
        </el-descriptions-item>
        <el-descriptions-item label="凭证标本馆存放地" prop="storagePlace" span="3">
          {{ infoContent.storagePlace }}
        </el-descriptions-item>
        <el-descriptions-item label="凭证标本馆藏号" prop="hideNo" span="3">
          {{ infoContent.hideNo }}
        </el-descriptions-item>

        <el-descriptions-item v-if="infoContent.pictureVideoFileList"
                              label="图片展示" span="3"  class="img">
          <!--         <template slot-scope="scope">-->
          <el-carousel :interval="2000" arrow="always" class="carousel">
            <el-carousel-item v-for="item in infoContent.pictureVideoFileList"
                              :key="item.id">
              <img :src="item.url" alt="" class="carousel-img">
            </el-carousel-item>
          </el-carousel>
          <!--         </template>-->
        </el-descriptions-item>
      </el-descriptions>
    </div>
    </div>
</template>

<script>
export default {
  name: "driedLeaf",
  props: {
    infoContent: Object,
    title: String
  }
}
</script>

<style scoped lang="scss">
.driedLeaf {
  .driedLeaf-lg {
    display: block;
  }
  .driedLeaf-sm {
    display: none;
  }
}
::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  text-align: center !important;
}
@media screen and (max-width: 1200px) {
  .driedLeaf {
    .driedLeaf-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
   .driedLeaf {
    .driedLeaf-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
   .driedLeaf {
    .driedLeaf-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .driedLeaf {
    .driedLeaf-lg {
      display: none;
    }
    .driedLeaf-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>